"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _Dropdown = require("@ccw-pwa-ui/Dropdown");
var _reactBootstrap = require("react-bootstrap");
require("../styles/AddStore.scss");
var _Input = require("@ccw-pwa-ui/Input");
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
var _Button = require("@ccw-pwa-ui/Button");
var _Modal = require("@ccw-pwa-ui/Modal");
const CreateStoreComponent = props => {
  const {
    sName,
    countries,
    zipcode,
    isZipCodeValid,
    address1,
    address2,
    city,
    state,
    phoneNo,
    setSName,
    setCountry,
    setZipcode,
    notificationsText,
    isValidPhoneNumber,
    numberInvalidText,
    setAddress1,
    setAddress2,
    setCity,
    setState,
    setPhoneNo,
    navigate,
    title,
    addNewStore,
    country,
    isFormValid
  } = props;
  const {
    code
  } = country;
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: true,
    md: true,
    xs: true,
    sm: true,
    className: "d-flex flex-column align-items-center fieldContainer p-0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex flex-column align-items-center",
    style: {
      overflowY: 'scroll',
      width: '100%',
      paddingBottom: '20px'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "inputField"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Add Store",
    variant: "header-text",
    headerStyle: {
      fontSize: 32,
      fontWeight: 600,
      lineHeight: '42px',
      color: '#0B3471',
      width: '180px',
      marginTop: '40px'
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "inputField"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Store Name",
    variant: "simple-text",
    headerStyle: {
      fontSize: 16,
      fontWeight: 600,
      color: '#333333',
      lineHeight: '22px'
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputStyle: {
      borderRadius: 10
    },
    placeholder: "Store Name",
    value: sName,
    onchange: setSName
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "inputField",
    "data-testid": "countriesDD"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Country",
    variant: "simple-text",
    headerStyle: {
      fontSize: 16,
      fontWeight: 600,
      color: '#333333',
      lineHeight: '22px'
    }
  }), /*#__PURE__*/_react.default.createElement(_Dropdown.Dropdown, {
    key: 'simple-text',
    selectedItem: title,
    dropdownList: countries,
    itemClick: setCountry
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "inputField"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Zipcode",
    variant: "simple-text",
    headerStyle: {
      fontSize: 16,
      fontWeight: 600,
      color: '#333333',
      lineHeight: '22px'
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    disabled: !title,
    inputStyle: {
      borderRadius: 10
    },
    placeholder: "Zip code",
    value: zipcode,
    onchange: setZipcode
  }), isZipCodeValid && /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Enter Valid Zipcode",
    variant: "simple-text",
    headerStyle: {
      fontSize: 12,
      fontWeight: 400,
      color: '#E00932',
      lineHeight: '22px'
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "inputField"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Address 1",
    variant: "simple-text",
    headerStyle: {
      fontSize: 16,
      fontWeight: 600,
      color: '#333333',
      lineHeight: '22px'
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    disabled: !title,
    placeholder: "Address 1",
    value: address1,
    onchange: setAddress1
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "inputField"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Address 2",
    variant: "simple-text",
    headerStyle: {
      fontSize: 16,
      fontWeight: 600,
      color: '#333333',
      lineHeight: '22px'
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    disabled: !title,
    placeholder: "Address 2(Not Required)",
    value: address2,
    onchange: setAddress2
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "inputField"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "City",
    variant: "simple-text",
    headerStyle: {
      fontSize: 16,
      fontWeight: 600,
      color: '#333333',
      lineHeight: '22px'
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    disabled: true,
    placeholder: "City",
    inputType: "",
    value: city,
    onchange: setCity
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "inputField"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "State",
    variant: "simple-text",
    headerStyle: {
      fontSize: 16,
      fontWeight: 600,
      color: '#333333',
      lineHeight: '22px'
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    disabled: true,
    placeholder: "State",
    inputType: "",
    value: state,
    onchange: setState
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "inputField",
    "data-testid": "test-phone"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Store Phone Number",
    variant: "simple-text",
    headerStyle: {
      fontSize: 16,
      fontWeight: 600,
      color: '#333333',
      lineHeight: '22px'
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'relative'
    },
    "data-testid": "phone-input"
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    dynamicTitleStyle: {
      color: '#333333',
      fontSize: 16
    },
    disabled: !title,
    placeholder: "Enter Store Phone Number",
    disableDropdown: true,
    countryCodeEditable: false,
    onlyCountries: ['us'],
    Countries: countries,
    inputType: "phone-input",
    value: phoneNo,
    onchange: setPhoneNo,
    country: code || 'us',
    notificationText: notificationsText,
    isValidPhoneNumber: isValidPhoneNumber,
    numberInvalidText: numberInvalidText,
    phoneNumberInputClass: isValidPhoneNumber ? "phone-input1" : "phone-input2"
    // onBlur={() => props.handlePhoneNumberBlur(true)}
  }), !isValidPhoneNumber ? /*#__PURE__*/_react.default.createElement("img", {
    style: {
      marginTop: -24
    },
    src: _index.default.warning.default,
    alt: "",
    className: "input-warning"
  }) : null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "inputField"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex flex-column"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "imageUploadHeaderText"
  }, props.imageUploadHeaderText)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("img", {
    src: props.imageUploadInfoIcon,
    alt: "",
    className: "imageUploadInfoIcon",
    onClick: props.imageUplaodInfoIconHandle,
    "data-testid": "infoIconImage"
  })))), props.currentImage ? /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex flex-column"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
    src: props.currentImage,
    alt: "",
    className: "imageDisplayedClass"
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    disabled: false,
    title: "Remove",
    buttonStyle: {
      backgroundColor: "white",
      color: "red",
      borderWidth: "0px",
      marginLeft: "-8px",
      marginTop: "-6px",
      marginBottom: "4px"
    },
    variant: "primary",
    onClick: props.handlePhotoRemove
  }))) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "imageUploadButton"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    disabled: false,
    variant: "outline-primary-long",
    title: "Upload a Photo",
    onClick: props.handleImageUpload
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "inputField"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    disabled: !isFormValid(),
    variant: "primary-long",
    title: "Add Store",
    onClick: addNewStore
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "inputField"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    onClick: navigate,
    variant: "outline-primary-long",
    title: "Cancel",
    buttonStyle: {
      width: '100%',
      justifyContent: 'center'
    }
  })), props.isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border"
  })) : null), props.displayPhotosModal && /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "pop-up"
  }, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: props.displayPhotosModal,
    modalDetailTextStyle: {
      marginBottom: '20px'
    },
    text4Style: [props.windowLayout ? {
      cursor: "no-drop",
      opacity: "0.4",
      fontFamily: 'Poppins',
      fontSize: '16px',
      fontWeight: 700,
      lineHeight: '24px',
      letterSpacing: '0px',
      textAlign: 'left',
      height: '50px',
      marginTop: '10px',
      marginBottom: '10px',
      borderBottom: "1px solid #EBEBEB"
    } : {
      fontFamily: 'Poppins',
      fontSize: '16px',
      fontWeight: 700,
      lineHeight: '24px',
      letterSpacing: '0px',
      textAlign: 'left',
      color: '#006E96',
      height: '50px',
      marginTop: '10px',
      marginBottom: '10px',
      borderBottom: "1px solid #EBEBEB"
    }, {
      fontFamily: 'Poppins',
      fontSize: '16px',
      fontWeight: 700,
      lineHeight: '24px',
      letterSpacing: '0px',
      textAlign: 'left',
      color: '#006E96',
      height: '50px',
      marginTop: '10px',
      marginBottom: '10px',
      borderBottom: "1px solid #EBEBEB"
    }],
    modalDetailText4: [{
      name: 'Take Photo',
      iconRight: props.isOneSelected,
      onSelect: () => props.onOptionSelect(1)
    }, {
      name: 'Photo Library',
      iconRight: props.isTwoSelected,
      imageButton: true,
      onSelect: () => props.onOptionSelect(2)
    }],
    imageButtonText: 'Continue',
    imageButton: props.continuePress,
    checkmark: props.checkmark,
    camDivStyle: props.camDivStyle,
    hideImageButton: props.hideImageButton,
    camLabelStyle: props.camLabelStyle,
    checkmarkStyle: props.checkmarkStyle,
    capture: props.isOneSelected ? 'camera' : null,
    cameraSelected: props.isOneSelected,
    videoRef: props.videoRef,
    ContinueText: props.saveText,
    fileSelected: props.isTwoSelected || props.isOneSelected,
    imageButtonAction: props.isOneSelected || props.isTwoSelected ? props.handleFileChange : null,
    negativeButtonActionTitle: props.cancelText,
    negativeAvtion: props.onModalCancel,
    imageButtonStyle: {
      width: '100%',
      height: '45px',
      fontWeight: 700,
      alignSelf: 'center'
    }
  })), props.duplicateModal && /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    variant: props.modalText.duplicateModalVariant,
    modalHeaderText: props.modalText.modalHeaderText,
    modalHeaderTextStyle: props.modalText.modalHeaderTextStyle,
    modalDetailText: props.modalText.modalDetailText,
    modalDetailTextStyle: {
      fontSize: 16,
      color: "#333333",
      fontWeight: 400,
      lineHeight: "22px",
      marginTop: "14px"
    },
    displayModal: props.duplicateModal,
    positiveActionButtonTitle: props.modalText.positiveActionButtonTitle,
    positiveAction: props.handleResendInviteModal
  }));
};
var _default = exports.default = CreateStoreComponent;